import * as React from 'react';
import { CustomButton, ButtonType, SpinnerWrapper, AlertMessage, AlertType } from 'soprasteria-ui-library';
import { IOrthodonticReferralPatientTreatment, IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { OrthodonticReferralTreatmentTable } from '../OrthodonticReferralTables/OrthodonticReferralTreatmentTable';
import { OrthodonticReferralTreatmentModal } from '../OrthodonticReferralModals/OrthodonticReferralTreatmentModal';
import { useAuth } from '../../../../App';
import { OrthodonticReferralTreatmentApi } from '../../../../api/OrthodonticReferralTreatmentApi';
import { setMessage } from '../../../../helpers/MessageHelper';

interface IOrthodonticReferralTreatments {
    orthodonticReferralId: number;
    orthodonticReferralStatusId: number;
    canReportTreatments?: boolean;
    minimumTreatmentDate?: Date;
    hasRoleAllmantandvard: boolean;
    hasRoleOrtodontisttandvard: boolean;
    treatments?: IOrthodonticReferralPatientTreatment[];
    getOrthodonticReferral: (orthodonticReferralId: number, refresh: boolean) => void;
    isICD10CodeAndTherapyRequired: boolean;
    referralClosedDate?: Date;
}

export const OrthodonticReferralTreatments: React.FunctionComponent<IOrthodonticReferralTreatments> = ({ orthodonticReferralId, orthodonticReferralStatusId, canReportTreatments, minimumTreatmentDate, hasRoleAllmantandvard, hasRoleOrtodontisttandvard, treatments, getOrthodonticReferral, isICD10CodeAndTherapyRequired, referralClosedDate }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralTreatmentApi(auth);
    const [renderForm, setRenderForm] = React.useState<boolean>(false);
    const [successMessage, setSuccessMessage] = React.useState<string>();

    const changeSuccessMessage = (message: string) => {
        const newMessage = setMessage(message, successMessage ?? "");
        changeSuccessMessage(newMessage);
    }

    const removeTreatment = (patientTreatmentId: number) => {
        api.removeOrthodonticReferralTreatment(patientTreatmentId, () => {
            setSuccessMessage("Åtgärdskoden har tagits bort");
            getOrthodonticReferral(orthodonticReferralId, true);
        });
    }

    const onTreatmentCredit = (patientTreatmentId: number) => {
        api.creditTreatment(patientTreatmentId, () => {
            const newMessage = setMessage("Åtgärdskoden inväntar kreditering", successMessage ?? "");
            setSuccessMessage(newMessage);
            getOrthodonticReferral(orthodonticReferralId, true);
        });
    }

    return (
        <>
            {
                !isICD10CodeAndTherapyRequired && (treatments && treatments.length > 0) || canReportTreatments ?
                    <>
                        <div className="row">
                            <label className="col-6">Åtgärdskoder</label>
                            <div className="col-6 text text-right">
                                {
                                    canReportTreatments ?
                                        <CustomButton buttonText="Lägg till åtgärdskod" className="text-right" data-toggle="modal" data-target="#add-orthodontic-referral-treatment-modal" buttonType={ButtonType.create} onClick={() => setRenderForm(true)} />
                                        : null
                                }
                            </div>
                        </div>
                        <div className="row">
                            {
                                treatments ?
                                    <div className="col-12">
                                        <OrthodonticReferralTreatmentTable treatments={treatments} onDelete={removeTreatment} canRemoveTreatments={canReportTreatments ?? false} onTreatmentCredit={onTreatmentCredit} />
                                    </div>
                                    : null
                            }
                        </div>
                        <OrthodonticReferralTreatmentModal 
                            orthodonticReferralId={orthodonticReferralId} 
                            orthodonticReferralStatusId={orthodonticReferralStatusId} 
                            minimumTreatmentDate={minimumTreatmentDate} 
                            setRenderForm={setRenderForm} 
                            renderForm={renderForm} 
                            changeSuccessMessage={setSuccessMessage} 
                            getOrthodonticReferral={getOrthodonticReferral} 
                            hasRoleOrtodontisttandvård={hasRoleOrtodontisttandvard} 
                            hasRoleAllmantandvard={hasRoleAllmantandvard} 
                            referralClosedDate={referralClosedDate} />
                        <hr />
                    </>
                    : null
            }
        </>
    )
}